export default __webpack_public_path__ + "static/errors-b7d56e9d4cc880ba475a027b1232ddd7.png";